import React, { useEffect, useState } from "react";
import { Cookie, X } from "lucide-react";
import { useI18n } from "@/lib/i18n";

const STORAGE_KEY = "adn_cookie_consent_v1";

function detectRegion() {
    try {
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
        if (tz.startsWith("Europe/") || tz === "Atlantic/Azores") return "EU";
        if (tz === "America/Los_Angeles" || tz === "America/Anchorage") return "CA";
        return "US";
    } catch { return "US"; }
}

export default function CookieBanner() {
    const { t } = useI18n();
    const [visible, setVisible] = useState(false);
    const [region] = useState(detectRegion);

    useEffect(() => {
        if (!localStorage.getItem(STORAGE_KEY)) setVisible(true);
    }, []);

    const choose = (mode) => {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({ mode, at: new Date().toISOString(), region }));
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div
            data-testid="cookie-banner"
            className="fixed bottom-3 left-3 right-3 md:left-auto md:right-3 md:max-w-md z-[9997] bg-[#0A1128] text-white border border-[#D4AF37]/40 rounded-md shadow-2xl p-4"
        >
            <div className="flex items-start gap-3">
                <Cookie className="w-5 h-5 text-[#D4AF37] mt-0.5 shrink-0" />
                <div className="flex-1">
                    <div className="font-heading text-sm">{t("cookies.title")}</div>
                    <p className="text-xs text-white/75 mt-1 leading-relaxed">
                        {t("cookies.body")}{" "}
                        <a href="/privacy" className="text-[#D4AF37] underline">{t("cookies.privacy_link")}</a>.
                    </p>
                    <div className="flex flex-wrap gap-2 mt-3">
                        <button
                            onClick={() => choose("accept_all")}
                            data-testid="cookie-accept"
                            className="text-xs font-semibold uppercase tracking-wider bg-[#9B1B30] text-white hover:bg-[#B8233C] border-b-2 border-[#D4AF37] px-3 py-1.5 rounded-sm"
                        >
                            {t("cookies.accept_all")}
                        </button>
                        <button
                            onClick={() => choose("essential_only")}
                            data-testid="cookie-essential"
                            className="text-xs font-semibold uppercase tracking-wider bg-white/10 text-white hover:bg-white/20 px-3 py-1.5 rounded-sm"
                        >
                            {t("cookies.essential")}
                        </button>
                    </div>
                </div>
                <button
                    onClick={() => choose("essential_only")}
                    aria-label="Dismiss"
                    className="text-white/55 hover:text-white p-1"
                    data-testid="cookie-close"
                >
                    <X className="w-4 h-4" />
                </button>
            </div>
        </div>
    );
}
